import React, { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck, faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../basics/interface/CustomModal"
import { COLORS } from "../../utilities/Constants"

// Confirmation de suppression des TROIS tableaux de résultats (dépannage /
// atelier / location). Remplace le DeleteModal legacy (react-responsive-modal
// + classes CSS) par la convention V2 « bouton hors modal » (src/CLAUDE.md) :
// la corbeille de la ligne ne fait qu'ouvrir ce modal, le spinner puis le ✓
// vivent dans le bouton, l'erreur s'affiche ici (thunks en silent : pas de
// toast en double).
//
// `status` = slice {deleting, deleted, error} du domaine. Le DELETE renvoie la
// recherche relancée : la ligne quitte le tableau et le modal se ferme seul
// après le ✓. Après une erreur, « Supprimer » redevient cliquable (réessai).
const ResultDeleteModal = ({ label, status, onConfirm, onClose }) => {
	const { deleting, deleted, error } = status
	const busy = deleting || deleted

	useEffect(() => {
		if (!deleted) return
		const t = setTimeout(onClose, 800)
		return () => clearTimeout(t)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [deleted])

	return (
		<CustomModal
			title="Supprimer la fiche ?"
			subtitle={label}
			onClose={busy ? () => {} : onClose}
			showCloseButton={!busy}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: onClose,
					disabled: busy,
				},
				{
					title: deleted ? (
						<FontAwesomeIcon icon={faCheck} />
					) : (
						"Supprimer"
					),
					styleName: "danger",
					onClick: onConfirm,
					disabled: busy,
					loading: deleting,
				},
			]}
		>
			<p style={styles.text}>Cette action est définitive.</p>
			{error && (
				<div style={styles.error}>
					<FontAwesomeIcon icon={faTimesCircle} />{" "}
					{error.message || "La suppression a échoué."}
				</div>
			)}
		</CustomModal>
	)
}

const styles = {
	text: {
		margin: 0,
		fontSize: 13,
		color: COLORS.textMuted,
	},
	error: {
		marginTop: 10,
		fontSize: 13,
		color: COLORS.danger,
		textAlign: "center",
	},
}

export default ResultDeleteModal
